<template>
  <div class="continer">
    <img src="../../assets/img/start.png" alt="">
    <ul>
      <li @click="_getexhibition(item.id)" v-for="(item,index) in startyList.slice(0,6)" :key="index">
        <h4>{{item.lable}}</h4>
        <h5>{{item.updataTime}}</h5>
      </li>
    </ul>
  </div>
</template>
<script>
import { exchange_query } from '../../api/user/index'
import {  ERR_OK } from '../../api/common/config'
export default {
  data() {
    return {
      startyList:[]
    }
  },
  mounted(){
    this._exchange_query()
  },
  methods:{
    _getexhibition(id) {
        this.$router.push({ path: '/alternating-details',query:{id} })
    },
    _exchange_query(){
      exchange_query({type:1,number:9,page:1}).then((res)=>{
        if( res.data.isok === ERR_OK ) {
          this.startyList = res.data.data.records
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .continer 
    width 100%
    height 254px
    display flex 
    flex-wrap wrap 
    justify-content space-between
    margin-bottom 24px
    img 
      flex 0 0 206px
    ul 
      flex 0 0 994px
      background rgba(255,255,255,1)
      box-shadow 0px 0px 7px 0px rgba(0, 0, 0, 0.06)
      border-radius 0px 4px 4px 0px
      display flex
      flex-wrap wrap 
      // justify-content space-between
      padding 6px 8px 
      box-sizing border-box
      li 
        // width 290px
        flex  0 0 300px
        height 78px
        padding 15px 18px 
        box-sizing border-box
        font-size 12px
        &:hover
          background rgba(245,245,245,1)
          border-radius 4px
          color #0D74FF
        h4 
          margin-bottom 8px
          width 250px
          height 34px
          // line-clamp 2
          overflow: hidden;
          // white-space: nowrap;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: 
          vertical;-webkit-line-clamp: 2;
</style>